module.exports = __webpack_public_path__ + "static/media/students-icon-2.fe352c4c.svg";